// Npm
import { Button } from '@nt/dds-react';
import React, { useMemo, useState } from 'react';

// Local
import { ItemsInprogressGridData, LinkDisplayData, StatusType } from '../../../../utils/types';
import Modal from '../../../common/Modal';
import StatusDetails from './StatusDetails';

interface Props {
  data: ItemsInprogressGridData;
}

const StatusButtonCellRenderer: React.FC<Props> = ({ data }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const getIconName = (status: string): string => {
    switch (status) {
      case StatusType.IN_PROGRESS:
        return 'cached';
      case StatusType.SUBMITTED:
        return 'check_circle';
      case StatusType.ACCOUNT_REQUESTED:
        return 'account_circle';
      default:
        return 'none';
    }
  };

  const linkDisplayData: LinkDisplayData = useMemo(() => {
    return { value: data?.status, iconName: getIconName(data?.status) };
  }, [data]);

  return (
    <>
      {data?.status && (
        <div className="status-button">
          <Button
            icon="left"
            iconName={linkDisplayData.iconName}
            kind="borderless"
            onClick={() => setIsModalOpen(true)}
            size="small"
            type="button"
          >
            {linkDisplayData.value}
          </Button>
          {isModalOpen && (
            <Modal
              alert={true}
              size="large"
              isOpen={isModalOpen}
              header={{
                onClose: () => setIsModalOpen(false)
              }}
              footer={{}}
            >
              <div className="modal-content-wrap">
                <StatusDetails entityData={data} />
              </div>
            </Modal>
          )}
        </div>
      )}
    </>
  );
};

StatusButtonCellRenderer.displayName = 'StatusButtonCellRenderer';
export default StatusButtonCellRenderer;
